<div class="container">
    <div class="row mt-5">
        <div class="col-md-12">
            <div class="text-center">
                <h1>Lista Accounts</h1>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-12 d-flex justify-content-end">
            <button class="btn btn-primary" (click)="aggiungiAccount()">Aggiungi Account</button>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-12 text-center">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th *ngIf="utente.gerarchia==0">Titolare</th>
                        <th>Nome Account</th>
                        <th>Broker</th>
                        <th>Numero</th>
                        <th>Tipo piattaforma</th>
                        <td>Modifica</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ac of accounts">
                        <td *ngIf="utente.gerarchia==0">{{ac.titolare}}</td>
                        <td>{{ac.nome}}</td>
                        <td>{{ac.broker}}</td>
                        <td>{{ac.numero}}</td>
                        <td>{{ac.piatta}}</td>
                        <td>
                            <button class="btn btn-primary" (click)="modificaAccount(ac.getID())">
                                <i class="fas fa-address-card"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>